import React from "react";

import tokenUtils from "utils/tokenUtils";
import { useSnackbarContext } from "widgets/SnackBar/SnackBar";
import { formatApiErrorForDisplay } from "helpers/packageManagementApi";

import { UPLOAD_HISTORY_COPY } from "../constants/uploadsContent";
import useDownloadProcessedFile from "../hooks/useDownloadProcessedFile";
import useUploadHistory from "../hooks/useUploadHistory";
import FileUploadsHistory from "./FileUploadsHistory/FileUploadsHistory";

const FileUploadsHistorySection = ({ scriptId }) => {
  const userId = tokenUtils.getUploaderUserId?.() ?? tokenUtils.getUserId?.();
  const { openSnackbar } = useSnackbarContext();

  const {
    isPending: isHistoryLoading,
    data: uploadHistory,
    isError,
    error,
    refetch,
  } = useUploadHistory(userId);

  const {
    mutate: downloadProcessedFile,
    isPending: isDownloadPending,
    variables: downloadingFileId,
  } = useDownloadProcessedFile();

  const handleDownloadProcessedFile = (fileId) => {
    if (!fileId) {
      return;
    }

    downloadProcessedFile(fileId, {
      onSuccess: (response) => {
        const link = document.createElement("a");
        link.href = response.signedUrl;
        link.click();
        openSnackbar(UPLOAD_HISTORY_COPY.DOWNLOAD_SUCCESS);
      },
      onError: (downloadError) => {
        openSnackbar(
          formatApiErrorForDisplay(
            downloadError,
            UPLOAD_HISTORY_COPY.DOWNLOAD_ERROR_FALLBACK
          ),
          "error"
        );
      },
    });
  };

  return (
    <FileUploadsHistory
      scriptId={scriptId}
      userId={userId}
      uploadHistory={uploadHistory}
      isHistoryLoading={isHistoryLoading}
      isError={isError}
      error={error}
      onRefetch={refetch}
      onDownloadProcessedFile={handleDownloadProcessedFile}
      downloadingFileId={isDownloadPending ? downloadingFileId : null}
    />
  );
};

export default FileUploadsHistorySection;
